import { useSearchParams } from 'react-router-dom';

// Components
import RegisterForm from '../components/RegisterForm';
import ErrorWrapper from '@/components/content/error/ErrorWrapper';
import Skeleton from '@/components/content/placeholder/Skeleton';
import RouterLink from '@/components/content/link/RouterLink';
import Title from '@/components/content/title/Title';

// Api
import { useGetUserInfoByToken } from '../services/getAuthInfo';

import classes from './Auth.module.css';

const Register = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') as string;
  const { data, isLoading, isRefetching, isError, error, refetch } = useGetUserInfoByToken(token);

  const errors = {
    401: {
      message: `Your registration token has expired. Please contact your dedicated customer
      success manager at <a href="mailto:support@quointelligence.eu">support@quointelligence.eu</a> for
      further assistance.`,
    },
    ...Object.fromEntries(
      ['404', '403'].map((k) => [
        k,
        {
          message: `This token has already been used or is invalid, contact your dedicated customer
          success manager at <a href="mailto:support@quointelligence.eu">support@quointelligence.eu</a> for
          further assistance.`,
          action: <RouterLink to="/">Go to Mercury</RouterLink>,
        },
      ])
    ),
  };

  return (
    <div className={classes.page} data-mantine-color-scheme="light">
      <ErrorWrapper isError={isError} error={error} errors={errors} refetch={refetch}>
        <div className={classes.standaloneCardColumn}>
          <div className={classes.content}>
            {isLoading || isRefetching ? (
              <Skeleton height={150} />
            ) : (
              <>
                <Title order={1}>Complete Registration</Title>

                <RegisterForm
                  prefillData={{
                    email: data?.email || '',
                    firstname: data?.firstname || '',
                    lastname: data?.lastname || '',
                    client_name: data?.client_name || '',
                  }}
                  external={data?.external_auth || false}
                  token={token}
                />
              </>
            )}
          </div>
        </div>
      </ErrorWrapper>
    </div>
  );
};

export default Register;
